import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3df753ec&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StatusDropDownMenu: require('/srv/rir-platform/tourism/src/tourism-front/components/common/StatusDropDownMenu/index.vue').default,Hint: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Hint/index.vue').default,Calendar: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Calendar/index.vue').default})
